<div class="vm-container cozy">
  <div class="vertical-align">
    <div class="vm-col-xs-12">
      <vm-confirmation
      [icon]="confirmationInput?.icon"
      [iconColor]="confirmationInput?.iconColor"
      [iconWeight]="confirmationInput?.iconWeight"
      [title]="confirmationInput?.title"
      [info]="confirmationInput?.info"
      [nextActions]="confirmationInput?.actions"
      [extraInfo]="confirmationInput?.extraInfo"
      [secondaryModalLabel]="confirmationInput?.secondaryModalLabel"
      [secondaryModalCopy]="confirmationInput?.secondaryModalCopy"
      [tertiaryModalLabel]="confirmationInput?.tertiaryModalLabel"
      [tertiaryModalTitle]="confirmationInput?.tertiaryModalTitle"
      [tertiaryModalCopy]="confirmationInput?.tertiaryModalCopy"
      [ctaContentTypeTitle]="confirmationInput?.actions[0]?.contentType"
      [chatbotId]="'faultsbuttonnew'"
      (next)="toUrl($event.url || $event.id)">    
      </vm-confirmation>
    </div>
  </div>
</div>
